"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    table: zod_1.z.string().describe('Data-lake table to wait for hydration'),
    anyFileVersion: zod_1.z
        .boolean()
        .optional()
        .describe('Set to true to wait for any fileVersion (its needed for *latest* tables not partitioned by fileVersion)'),
    initiateJobIfPartitionExists: zod_1.z
        .boolean()
        .optional()
        .describe('Set to true to check if the table has already been refreshed for the reportingDate/fileVersion of interest.  This likely should not be used if querying a *latest* table.'),
});
exports.nodeType = 'file_waitForDataLakeTable';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
exports.artifactType = 'waitForDataLakeTable';
//# sourceMappingURL=types.js.map